import Vue from "vue";
let currentRequest = 0;

const AgreementServiceService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("agreementServices", id, {
        include: "service,agreement"
      });
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START AGREEMENT_SERVICE `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "agreementServices",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] AGREEMENT_SERVICE DISCARDED`);
        return null;
      }
      console.log(`[${request}] END AGREEMENT_SERVICE `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  }
};

export { AgreementServiceService };
